import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

// Context
import { AuthProvider } from '../utilities/auth-context';

// Toast Provider
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Main Components
import CheckAuth from './auth/check-auth';
import AuthenticatedRoutes from './authenticated-routes';
import Header from './global/header';

import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import theme from '../utilities/theme';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// MUI Components
import Box from '@mui/material/Box';

const MainRouter = () => {

    const [isAuthenticated, setIsAuthenticated] = useState(null);

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CssBaseline />
            <div id='main-router'>
                <AuthProvider>
                    <CheckAuth onAuthenticate={setIsAuthenticated} />
                    <Router basename={process.env.REACT_APP_BASE_URL === 'http://127.0.0.1/smv2-admin' ? '/smv2-admin' : ''}>
                        <Header isAuthenticated={isAuthenticated} />
                        <Box className='main-router-content'>
                            <AuthenticatedRoutes 
                                isAuthenticated={isAuthenticated} 
                                setIsAuthenticated={setIsAuthenticated} 
                            />
                        </Box>
                    </Router>
                </AuthProvider>
                <ToastContainer
                    position="top-right"
                    theme="light"
                    autoClose={5000}
                    newestOnTop={false}
                />
            </div>
            </LocalizationProvider>
        </ThemeProvider>
    )
}

export default MainRouter;